import React from 'react';

import './RydRollHeaderGroup.css';

interface RydRollHeaderGroupProps {
    children: React.ReactNode;
}

const RydRollHeaderGroup: React.FC<RydRollHeaderGroupProps> = ({ children }) => {
    return <div className={"ryd-roll-header-group"}>{children}</div>;
};

export default RydRollHeaderGroup;